import type { MeetingTopic, MeetingTopicsResponse } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchMeetingTopics(context: ApiContext): Promise<MeetingTopicsResponse> {
  return apiContextFetch<MeetingTopicsResponse>(context, "meeting_topics")
}

export function createMeetingTopic(context: ApiContext, meetingTopic: Partial<MeetingTopic>) {
  return apiContextFetch<MeetingTopic>(context, "meeting_topics", {
    method: "POST",
    body: JSON.stringify({ meeting_topic: meetingTopic }),
  })
}

export function updateMeetingTopic(context: ApiContext, id: string, meetingTopic: Partial<MeetingTopic>) {
  return apiContextFetch<MeetingTopic>(context, `meeting_topics/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ meeting_topic: meetingTopic }),
  })
}

export function archiveMeetingTopic(context: ApiContext, id: string) {
  return apiContextFetch<void>(context, `meeting_topics/${id}`, { method: "DELETE" })
}

export function unarchiveMeetingTopic(context: ApiContext, id: string) {
  return updateMeetingTopic(context, id, { archived_at: null })
}
